import React from "react";
import {createRoot} from "react-dom/client";
import {computePosition, flip, shift, offset} from "@floating-ui/dom";
import {useEffect, useState} from "react";

document.addEventListener('DOMContentLoaded', function () {

    const elem = document.createElement('div');
    elem.id = 'js-popup-no-contragent'
    elem.className = 'absolute top-0 left-0 max-w-max z-30'
    document.body.appendChild(elem);
    const popUp = createRoot(elem);

    document.addEventListener('showHideDetailItemPopupPopup', function (event) {
        const node = document.querySelector('#js-popup-no-contragent')
        computePosition(event.detail.elem, node, {
            placement: 'bottom-right',
            middleware: [offset(10), flip(), shift({padding: 10})]
        }).then(({x, y}) => {
            Object.assign(node.style, {
                left: `${x}px`,
                top: `${y}px`,
            })
        })
        popUp.render(<PopUpNoContragents  hash={new Date()}/>)
    })
    const PopUpNoContragents = (props) => {
        const [visible, setVisible] = useState(false)

        useEffect(() => {
            if (props?.hash) {
                setVisible(true)
            } else {
                setVisible(false)
            }
        }, [props?.hash]);

        return (
            <div className={`text-black font-extralight text-center p-5 shadow-lg popup-window-price
                                bg-filterGray dark:text-textDarkLightGray text-xs dark:bg-grayButton rounded-lg w-72
                                z-50 left-0 ${!visible ? 'hidden' : ''}`}>
                <p className="flex justify-center">
                    <svg width="20" height="20" viewBox="0 0 24 24"
                         className="mb-3 stroke-light-red dark:stroke-white"
                         fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="11" strokeWidth="2"/>
                        <line x1="12" y1="11" x2="12" y2="18" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                        <line x1="12" y1="7" x2="12" y2="6" strokeWidth="2" strokeLinecap="round"
                              strokeLinejoin="round"/>
                    </svg>
                </p>
                У вас нет активных контрагентов для совершения покупок на этом сайте!<br/>
                Вы можете
                <a href="/personal/contragents/"
                   className="text-light-red dark:text-white font-medium">Создать контрагента</a>
                и обратиться к менеджеру <br/>
                или перейти на наш
                <a href="https://oshisha.net"
                   className="text-light-red dark:text-white font-medium">Розничный сайт</a>
                <span className="absolute -right-2 -top-2 cursor-pointer"
                      onClick={() => setVisible(false)}>
                                        <svg width="25" height="25" viewBox="0 0 60 60" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.7"
                                                  d="M55 30C55 43.807 43.807 55 30 55C16.1929 55 5 43.807 5 30C5 16.1929 16.1929 5 30 5C43.807 5 55 16.1929 55 30Z"
                                                  fill="#676767"></path>
                                            <path
                                                d="M22.4242 22.4242C23.1564 21.6919 24.3436 21.6919 25.0757 22.4242L30 27.3485L34.9242 22.4242C35.6565 21.692 36.8435 21.692 37.5757 22.4242C38.308 23.1564 38.308 24.3436 37.5757 25.076L32.6517 30L37.5757 34.924C38.308 35.6562 38.308 36.8435 37.5757 37.5757C36.8435 38.308 35.6562 38.308 34.924 37.5757L30 32.6517L25.076 37.5757C24.3436 38.308 23.1564 38.308 22.4242 37.5757C21.692 36.8435 21.692 35.6565 22.4242 34.9242L27.3485 30L22.4242 25.0757C21.6919 24.3436 21.6919 23.1564 22.4242 22.4242Z"
                                                fill="white"></path>
                                        </svg>
                </span>
            </div>
        )
    }

    popUp.render(<PopUpNoContragents />)
})